module.exports = {"name":"summaryClick","on":[]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/signals/outputs/summary-click.json
// module id = XeaD
// module chunks = 0